window.BettingCart = (function () {

    var mode = 'Standard', // OneClick || Standard
        dom = {},
        isLoading = false,
        isSending = false,
        isCollapsed = false;

    var currencyMap = {
        CURRENCY: window.globalAppSettings.currentUser.defaultBalance.currencyCode,
        BONUS: 'Bonuses'
    };

    var isWaitingForLiveBet = false,
        liveBetTimeout = undefined,
        sendingLiveIds = [];

    var isFirstCoefAdded = false;
    const NOTIFICATION_BEHAVIOUR_KEY = 'first-coef-added';
    var addItemObsolete = function (data) { // return false if cart is sending now or overflowed, return true if added or already added.  Blink on false
        var result;

        data = {
            aId: data.aId,
            eId: data.eId,
            eTitle: data.eTitle || '',
            isLive: data.isLive,
            oId: data.oId,
            rTitle: data.rTitle || '',
            val: data.val,
            loadActualCoefValue: data.loadActualCoefValue || false
        };

        if (mode === 'Standard') {
            result = StandardCart.addItem(data);

            if (isCollapsed) {
                expand();
            }

            if (result === false)
                visual.blink();
        }
        else if (mode === 'Oneclick') {
            if (OneclickCart.isSending)
                visual.blink();
            result = OneclickCart.sendData(data);
        }

        if (result && !isFirstCoefAdded) {
            Behaviours.NotificationBehaviour.ShowModalWindow(NOTIFICATION_BEHAVIOUR_KEY);
            isFirstCoefAdded = true;
        }


        return result;
    };

    var addItem = function (itemData) {
        var result = false;

        var data = {
            oId: itemData.oId,
            aId: itemData.aId,
            val: itemData.val,
            eId: itemData.eId,
            isLive: itemData.isLive,
            loadActualCoefValue: true
        };

        if (mode === 'Standard') {
            result = StandardCart.addItem(data);

            if (isCollapsed) {
                expand();
            }

            if (result === false)
                visual.blink();
        }
        else if (mode === 'Oneclick') {
            if (OneclickCart.isSending)
                visual.blink();
            result = OneclickCart.sendData(data);
        }

        if (result && !isFirstCoefAdded) {
            Behaviours.NotificationBehaviour.ShowModalWindow(NOTIFICATION_BEHAVIOUR_KEY);
            isFirstCoefAdded = true;
        }

        return result;
    };


    var removeItem = function (originalId) { // return false if cart is sending now, return true if removed or already removed.  Blink on false
        var result;

        if (mode === 'Standard') {
            if (isSending || isLoading) {
                result = false;
            }
            else {
                StandardCart.removeItem(originalId);
                result = true;
            }
        }
        else if (mode === 'Oneclick') {
            result = OneclickCart.removeItem(originalId);
        }

        if (result === false)
            visual.blink();

        return result;
    };

    var getItems = function () { //TODO: делать ветвление через switch
        if (mode === 'Standard') {
            return StandardCart.getItems();
        }
        else if (mode === 'Oneclick') {
            return OneclickCart.getItems();
        }
    };

    var hasItem = function (oid) {
        var currentItems = getItems();
        return currentItems.hasOwnProperty(oid);
    };

    //#region ПЛОХИЕ ФУНКЦИИ

    var Highlighting = (function () {
        const cellSelectors = {
            table: '.events-table__markets-cell',
            openEvent: '.event-markets__coef',
            accent: '.multi-event-coef',
        };

        function activate(cellSelector, activateAll) {
            activateAll === true ? true : false;
            var currentItems = getItems();
            if (Object.keys(currentItems).length > 0) {
                for (oid in currentItems) {
                    if (activateAll) {
                        for (key in cellSelectors) {
                            $(cellSelectors[key] + '[data-oid=' + oid + ']').addClass('active');
                        }
                    }
                    else {
                        $(cellSelector + '[data-oid=' + oid + ']').addClass('active');
                    }

                }
            }
        }

        function deactivateAllScopes(oid) {
            for (key in cellSelectors) {
                $(cellSelectors[key] + '[data-oid=' + oid + ']').removeClass('active');
            }

            $(document).trigger('deactivateCoefHightlight', [oid]);
        };

        function deactivateOtherModes() {
            var otherItems;
            if (mode === 'Standard') {
                otherItems = OneclickCart.getItems();
            }
            else if (mode === 'Oneclick') {
                otherItems = StandardCart.getItems();
            }
            for (oid in otherItems) {
                deactivateAllScopes(oid);
            }
        };

        return {
            activate: {
                table: function () { activate(cellSelectors.table) },
                openEvent: function () { activate(cellSelectors.openEvent) },
                accent: function () { activate(cellSelectors.accent) },
                allScopes: function () { activate(null, true) }
            },
            deactivate: {
                allScopes: deactivateAllScopes,
                otherModes: deactivateOtherModes
            }
        }

    })();
    //#endregion


    //центровка лодера на экране при большом кол-ве ставок
    function heightCorrectionLoader() {
        if ($('.cart__inner').height() > $('#layout-right-column').height()) {
            $('.betting-cart__loader-spiner-wrapper').addClass('m-sticky');
        } else if (globalAppSettings.isMobileDevice) {
            $('.betting-cart__loader-spiner-wrapper').addClass('m-sticky');
        };
    };

    var visual = {
        blink: function () {
            dom.container.animate({ opacity: 0 }, 100).animate({ opacity: 1 }, 100);
        },
        showLoader: function () {
            heightCorrectionLoader();
            dom.overlay.fadeIn(200);
        },
        hideLoader: function () {
            $('.betting-cart__loader-spiner-wrapper').removeClass('m-sticky');
            dom.overlay.fadeOut(200);
        }
    };

    const COEF_UPD_INFO = {
        ORIGINAL_ID: 'o',
        ACTUAL_ID: 'a',
        VALUE: 'v',
        STATE: 's'
    };

    var notification = {
        NotifyPackageBetResult: function (isSuccess, message) {
            var packageBetStatusElement = $('[package-bet-status-container]');
            if (packageBetStatusElement.length > 0) {
                app.enableLoading();
                Ajax.postJson("/baltsystem/showpackagebetstatus", {
                    success: function () {
                        app.disableLoading();
                    }
                });
            }
        },
        //v2.0
        updateAccountBonusPoints: function (val) {
            StandardCart.bonusExpress.checkIfIsAvailable();
            //TODO: обновлять ББ на странице баланса.
        }

    };

    var calc = function () {
        var type = '',
            items = {},
            betSum = 0,
            result = {};

        if (mode === 'Standard') {
            type = StandardCart.getType();
            items = StandardCart.getItems();
            betSum = StandardCart.getBetSum();
            currency = StandardCart.getCurrency();
            isBonusExpress = StandardCart.bonusExpress.isEnabled;

            if (Freebet.isSelected()) {
                var freebetSum = Freebet.getSum();

                if (StandardCart.isTypeSingle()) {
                    items = {};

                    var selectedItemForFreebet = StandardCart.getSelectedItemForFreebet();

                    if (selectedItemForFreebet) {
                        items[selectedItemForFreebet.originalId] = selectedItemForFreebet;
                    }
                }

                items = Object.values(items).reduce(function (acc, cur) {
                    acc[cur.originalId] = Object.assign({}, cur);
                    acc[cur.originalId].bet = freebetSum;
                    return acc;
                }, {});

                betSum = freebetSum;
            }

            result = StandardCartCalc.calc(type, betSum, items, currency, isBonusExpress);
            StandardCart.updateCalcResults(result);
        }

        save();
    };

    var save = function () {
        if (isLoading === false) {
            var accountId = sessionStorage.getItem('accountId');
            var BettingCartData = {};

            app.console.log(mode);

            BettingCartData[accountId] = {
                timestamp: Date.now(),
                mode: mode,
                standardCartData: StandardCart.getData(),
                oneclickCartData: OneclickCart.getData(),
                isCollapsed: isCollapsed
            };

            localStorage.setItem('bettingCart', JSON.stringify(BettingCartData));
        }
    };

    var sendWithFreebetProposal = function () {
        if (mode === 'Standard' && StandardCart.canProposeFreeBet()) {
            Freebet.proposeCouponList();
            return false;
        }

        return send();
    };

    var initSendingLiveIds = function () {
        sendingLiveIds = Object.values(StandardCart.getItems()).filter(x => x.isLive).map(x => Number(x.originalId));
    };


    var cancelLiveBet = function (item) {
        if (StandardCart.getType() == 'Single') {
            var indexOfItem = sendingLiveIds.indexOf(Number(item.originalId));
            if (indexOfItem !== -1) {
                sendingLiveIds.splice(indexOfItem, 1);
                if (sendingLiveIds.length != 0)
                    return;
            }
        }

        clearTimeout(liveBetTimeout);
        liveBetTimeout = undefined;
        isWaitingForLiveBet = false;

        BettingCart.visual.hideLoader();
        BettingCart.isSending = false;
    };


    var sendToServer = function (data) {
        Ajax.postJson("/BettingCart/SendBettingCart", {
            data: {
                cartData: data,
                couponId: Freebet.isSelected() ? Freebet.getFreebetId() : null,
                duplicateToken: app.generateGUID() + ':' + Date.now()
            },
            success: function (resp) {

                if (resp.IsSuccess && resp.FailedPositions.length === 0) {
                    StandardCart.removeAllItemsAfterSend(resp.CoefsToRemove);
                    StandardCart.showSuccessMessage(resp.NeedConfirmation);
                    if (Freebet.isSelected()) {
                        Freebet.updateAfterSuccessSend();
                    }
                } else {
                    if (resp.FailedPositions && resp.FailedPositions.length > 0) {
                        var badIds = [];
                        var items = StandardCart.getItems();

                        for (var i = 0; i < resp.FailedPositions.length; i++) {
                            var oId = resp.FailedPositions[i].OriginalCoefId;

                            if (items[oId]) {
                                items[oId].errors.length = 0;
                                items[oId].errors.push(resp.FailedPositions[i].ErrorMessage);
                                items[oId].showErrors();
                                items[oId].animateFail();
                                badIds.push(parseInt(oId));
                            }
                        }

                        for (key in items) {
                            var item = items[key];
                            if (badIds.indexOf(parseInt(item.originalId)) == -1) {
                                    var removeAfter = (resp.CoefsToRemove && resp.CoefsToRemove.indexOf(parseInt(item.originalId)) !== -1)
                                    item.animateSuccess(removeAfter);
                            }
                        }

                        StandardCart.humanizeErors.items();

                    } else {
                        for (key in items) {
                            items[key].animateFail();
                        }
                    }

                    if (Freebet.isSelected()) {
                        Freebet.updateAfterFailedSend();
                    }

                    if (resp.IsUnauthorized) {
                        StandardCart.showErrors(Localization.getString('BettingCart.LoginToBet', 'Для совершения ставки необходимо авторизоваться.'));
                    }

                    if (resp.CommonErrorMessage) {
                        StandardCart.showErrors([resp.CommonErrorMessage]);
                        StandardCart.humanizeErors.general();
                    }
                }

                    BettingCart.visual.hideLoader();
                    BettingCart.isSending = false;
                //TODO: 12min timer
            }
        });
    }

    var send = function () {
        if (BettingCart.isSendAllowed === false)
            return false;

        if (mode !== 'Standard')
            return false;

        var data = {
            type: StandardCart.getType(),
            bettingCartInfo: {
                TotalMoneyValue: 0,
                TotalMoneyCurrency: currencyMap.CURRENCY,
                NotWinEventCount: 0,
            },
            bettingCartPositions: [],
        };
        data = StandardCart.prepareData(data);

        BettingCart.isSending = true;
        BettingCart.visual.showLoader();

        return sendToServer(data);
    };

    var load = function () {
        var accountId = sessionStorage.getItem('accountId');
        isLoading = true;

        if (!globalAppSettings.isMobileDevice) {
            scrollbar = new AwesomeScrollbar('#betting-cart__scroll-area', 'betting-cart__scrollbar-area-wrapper');
        }
        dom = {
            container: $('[js-node="betting-cart"]'),
            modeSwitcher: $('[js-node="betting-cart__mode-switcher"]'),
            modeSwitcherWrapper: $('[js-node="betting-cart__mode-switcher-wrapper"]'),
            overlay: $('[js-node="betting-cart__overlay"]'),
            collapseButton: $('[js-node="cart__collapse-button"]')
        };

        setTimeout(function () {
            dom.container.removeClass('is-loading');
        }, 500);


        var modeSwitcherWrapperSettings = globalAppSettings.currentUser.bettingCart.modeSwitcherWrapper;
        if (!!modeSwitcherWrapperSettings.IsEnabled) {
            dom.modeSwitcherWrapper.removeClass('m-disabled');
        }
        else {
            dom.modeSwitcherWrapper.addClass('m-disabled');
        }

        if (!!modeSwitcherWrapperSettings.Tooltip) {
            dom.modeSwitcherWrapper.attr('bb-tool', modeSwitcherWrapperSettings.Tooltip);
        }
        else {
            dom.modeSwitcherWrapper.removeAttr('bb-tool');
        }

        var cartSettingsButtonSettings = globalAppSettings.currentUser.bettingCart['cart-settings-button'];
        if (!!cartSettingsButtonSettings.IsEnabled) {
            $('#cart-settings-button').removeClass('m-disabled');
        }
        else {
            $('#cart-settings-button').addClass('m-disabled');
        }

        if (globalAppSettings.currentUser.isCaptchaRequired) {
            dom.modeSwitcherWrapper.addClass('m-disabled');
        }

        var cart = JSON.parse(localStorage.getItem('bettingCart')),
            oneclickCartData,
            standardCartData;

        if (cart) {
            if (cart.hasOwnProperty('unauthorized') && accountId !== 'unauthorized') {
                cart[accountId] = cart['unauthorized'];
                delete cart['unauthorized'];
                localStorage.setItem('bettingCart', JSON.stringify(cart));
            }

            if (cart[accountId]) {
                mode = cart[accountId].mode;

                if (cart[accountId].isCollapsed) {
                    collapse();
                } else {
                    expand();
                }

                if (cart[accountId].hasOwnProperty('oneclickCartData')) {
                    oneclickCartData = cart[accountId]['oneclickCartData'];
                }

                if (cart[accountId].hasOwnProperty('standardCartData')) {
                    standardCartData = cart[accountId]['standardCartData'];
                }
            }
        }

        StandardCart.load(standardCartData);
        OneclickCart.load(oneclickCartData);
        setMode(mode, true);

        if (validate()) {
            StandardCart.serverValidate();
        }

        bindUI();

        isLoading = false;
        document.dispatchEvent(new CustomEvent('bettingCartIsLoaded'))
    };

    var validate = function () {
        if (mode === 'Standard') {
            return StandardCart.validate();
        }
    };

    /**
     *
     * @param newMode String 'standard' || 'oneclick'
     */
    var setMode = function (newMode, justLoaded) {
        mode = newMode.toLowerCase() === 'oneclick' ? 'Oneclick' : 'Standard';

        if (mode === 'Oneclick') {
            dom.container
                .removeClass('standard')
                .addClass('oneclick');

            dom.modeSwitcher.prop('checked', true);
        } else {
            dom.container
                .addClass('standard')
                .removeClass('oneclick');

            dom.modeSwitcher.prop('checked', false);
        }

        if (justLoaded === undefined || justLoaded === false) {
            //deactivate prevState items. activate currentState
            Highlighting.deactivate.otherModes();
            Highlighting.activate.allScopes();
        }
        save();
    };

    var bindUI = function () {
        dom.modeSwitcher.on('change', function () {
            if (!globalAppSettings.currentUser.bettingCart.modeSwitcherWrapper.IsEnabled) return;

            var newMode = $(this).prop('checked') === true ? 'oneclick' : 'standard';
            setMode(newMode);
        });

        dom.collapseButton.on('click', function () {
            if (isCollapsed) {
                expand();
            } else {
                collapse();
            }
        });

        window.addEventListener('notificationBonusesUpdate', function (event) {
            const bonuses = 'detail' in event && event.detail.bonusPoints ? event.detail.bonusPoints : 0;

            notification.updateAccountBonusPoints(bonuses);
        });
    };

    var expand = function () {
        isCollapsed = false;
        dom.container.removeClass('collapsed');
        save();
    }

    var collapse = function () {
        isCollapsed = true;
        setMode('standard');
        dom.container.addClass('collapsed');
        save();
    };

    var getIsLoading = function () {
        return isLoading;
    };

    var settings = (function () {
        var selectors = {
            openButton: '#cart-settings-button',
            overlay: '#cart-settings-overlay'
        };

        var dom = {
            container: $('#cart-settings'),
            openButton: $(selectors.openButton),
            overlay: $('<div/>', {
                class: 'cart-settings__overlay',
                id: 'cart-settings-overlay'
            })
        };

        var actions = {
            open: function () {
                if (dom.openButton.hasClass('m-disabled'))
                    return false;

                document.dispatchEvent(
                    new CustomEvent('mtmCustomEvent', {
                        detail: {
                            id: 'd-i06-e3',
                        },
                    })
                );

                dom.openButton.addClass('m-active');
                dom.container.addClass('m-opened');
                $('[js-node="betting-cart"]').append(dom.overlay);
                $(document).on('click.cartSettingsClose, touchstart.cartSettingsClose', selectors.overlay + ',' + selectors.openButton, actions.close);
            },
            close: function () {
                document.dispatchEvent(
                    new CustomEvent('mtmCustomEvent', {
                        detail: {
                            id: 'd-i06-e4',
                        },
                    })
                );
                dom.openButton.removeClass('m-active');
                dom.container.removeClass('m-opened');
                dom.overlay.remove();
                $(document).off('click.cartSettingsClose, touchstart.cartSettingsClose');
            }
        };

        var bindUI = function () {
            $(document).on('click.cartSettingsOpen', selectors.openButton, actions.open);
        };

        var unbindUI = function () {
            $(document).off('click.cartSettingsOpen');
        };

        return {
            bindUI: bindUI,
            open: actions.open,
            close: actions.close
        };
    }());



    return {
        addItemObsolete: addItemObsolete,
        addItem: addItem,
        calc: calc,
        currencyMap: currencyMap,
        removeItem: removeItem,
        getItems: getItems,
        getIsLoading: getIsLoading,
        hasItem: hasItem,
        load: load,
        save: save,
        send: send,
        sendWithFreebetProposal: sendWithFreebetProposal,
        settings: settings,
        setMode: setMode,
        validate: validate,
        visual: visual,
        isOneClick: function () { return (mode.toLowerCase() === 'oneclick') },
        notification: notification,
        Highlighting: Highlighting,
        isSendAllowed: true
    };
}());